module.exports = __webpack_public_path__ + "static/media/launch.3c595492.webp";